import React, { createContext, useState, useContext } from 'react';

const translations = {
    en: {
        // General
        "Dashboard": "Dashboard",
        "Income": "Income",
        "Expense": "Expense",
        "Directory": "Directory",
        "Payments": "Payments",
        "Reports": "Reports",
        "Audit Trail": "Audit Trail",
        "Toggle Language": "Toggle Language",
        "Logout": "Logout",
        
        // Dashboard
        "Dashboard Overview": "Dashboard Overview",
        "Financial summary for the current period.": "Financial summary for the current period.",
        "Net Income vs Expense": "Net Income vs Expense",
        "Income vs Expense Distribution": "Income vs Expense Distribution",
        "Cashflow (Received vs Going)": "Cashflow (Received vs Going)",
        "Income / Sales": "Income / Sales",
        "Record sales invoices & incoming funds": "Record sales invoices & incoming funds",
        "Total Billed & Settled In": "Total Billed & Settled In",
        "Total Billed & Settled Out": "Total Billed & Settled Out",
        "Expense / Purchase": "Expense / Purchase",
        "Track vendor bills & purchases": "Track vendor bills & purchases",
    // "Total Purchases": "Total Purchases",
        "Payment Master": "Payment Master",
        "Two-way settlement ledger": "Two-way settlement ledger",
        "Net Cashflow": "Net Cashflow",
        "Reports Desk": "Reports Desk",
        "Dynamic ledger history & export": "Dynamic ledger history & export",
        "P&L Balance": "P&L Balance",

        // Party Master
        "Party Master": "Party Master",
        "Manage your Suppliers and Customers": "Manage your Suppliers and Customers",
        "Add Party": "Add Party",
        "Party Name": "Party Name",
        "Role": "Role",
        "GSTIN": "GSTIN",
        "Contact": "Contact",
        "Loading directory...": "Loading directory...",
        "No parties found. Add one to get started.": "No parties found. Add one to get started.",
        "Add New Party": "Add New Party",
        "Smart GST Auto-Fetch": "Smart GST Auto-Fetch",
        "Enter 15-digit GSTIN": "Enter 15-digit GSTIN",
        "Fetch": "Fetch",
        "Party Role": "Party Role",
        "Customer (Buyer)": "Customer (Buyer)",
        "Supplier (Vendor)": "Supplier (Vendor)",
        "Business Name *": "Business Name *",
        "Full Address": "Full Address",
        "Contact Email": "Contact Email",
        "Contact Phone": "Contact Phone",
        "Cancel": "Cancel",
        "Save Party": "Save Party",
        "Or enter details manually below if API fails": "Or enter details manually below if API fails",

        // Income Desk
        "Income & Sales Desk": "Income & Sales Desk",
        "Record sales invoices, client receivables & incoming funds": "Record sales invoices, client receivables & incoming funds",
        "New Income Entry": "New Income Entry",
        "Date": "Date",
        "Category": "Category",
        "Select Customer (Party)": "Select Customer (Party)",
        "-- Select Customer --": "-- Select Customer --",
        "Itemized Details": "Itemized Details",
        "Item Name / Service": "Item Name / Service",
        "Qty": "Qty",
        "Rate (₹)": "Rate (₹)",
        "GST %": "GST %",
        "Total": "Total",
        "Add Another Item": "Add Another Item",
        "Grand Total": "Grand Total",
        "Record Income": "Record Income",
        "Saving...": "Saving...",
        "Recent Sales": "Recent Sales",
        "Description": "Description",
        "Amount": "Amount",
        "Actions": "Actions",
        "Preview": "Preview",
        "Send": "Send",
        "No recent income entries found.": "No recent income entries found.",
        "Email Invoice PDF": "Email Invoice PDF",
        "Invoice Details:": "Invoice Details:",
        "Recipient Email Address": "Recipient Email Address",
        "Send PDF": "Send PDF",
        "Invoice Preview": "Invoice Preview",
        "Email PDF": "Email PDF",
        "Download PDF": "Download PDF",

        // Expense Desk
        "Expense & Purchase Desk": "Expense & Purchase Desk",
        "Track vendor bills, operational outlays & purchase receipts": "Track vendor bills, operational outlays & purchase receipts",
        "New Expense Entry": "New Expense Entry",
        "Select Vendor (Supplier)": "Select Vendor (Supplier)",
        "-- Select Vendor --": "-- Select Vendor --",
        "Bill Items Details": "Bill Items Details",
        "Item Name / Service / Bill Ref": "Item Name / Service / Bill Ref",
        "Record Expense": "Record Expense",
        "Recent Purchases": "Recent Purchases",
        "Receipt Preview": "Receipt Preview",
        "No recent expense entries found.": "No recent expense entries found.",

        // Payment Desk
        "Payment Master Desk": "Payment Master Desk",
        "Two-way settlement ledger: Payment Received vs Payment Going": "Two-way settlement ledger: Payment Received vs Payment Going",
        "Record Settlement": "Record Settlement",
        "Flow Type": "Flow Type",
        "Received (In)": "Received (In)",
        "Going (Out)": "Going (Out)",
        "Payment Mode": "Payment Mode",
        "Amount (₹)": "Amount (₹)",
        "Total Received": "Total Received",
        "Total Going": "Total Going",
        "Settlement Ledger": "Settlement Ledger",
        "Last 10 entries": "Last 10 entries",
        "Party": "Party",
        "Mode": "Mode",
        "Received": "Received",
        "Going": "Going",
        "No payment records found.": "No payment records found.",

        // Reports Desk
        "Reports & Reconciliation": "Reports & Reconciliation",
        "Dynamic ledger history & export center": "Dynamic ledger history & export center",
        "Financial Year": "Financial Year",
        "Start Date": "Start Date",
        "End Date": "End Date",
        "Types": "Types",
        "All Types": "All Types",
        "Selected": "Selected",
        "Categories": "Categories",
        "All Categories": "All Categories",
        "Select All": "Select All",
        "Deselect All": "Deselect All",
        "Export CSV": "Export CSV",
        "Export PDF": "Export PDF",
        "Period Inflow": "Period Inflow",
        "Period Outflow": "Period Outflow",
        "Net Period Balance": "Net Period Balance",
        "Type": "Type",
        "Party Name": "Party Name",
        "Loading ledger data...": "Loading ledger data...",
        "No records found for selected filters.": "No records found for selected filters.",
        "Payment In": "Payment In",
        "Payment Out": "Payment Out",

        // Toast and Dynamic strings
        "Please select a party": "Please select a party",
        "Please add at least one valid line item": "Please add at least one valid line item",
        "Invoice to": "Invoice to",
        "Customer": "Customer",
        "Income recorded successfully": "Income recorded successfully",
        "Failed to record income": "Failed to record income",
        "Invoice sent successfully to": "Invoice sent successfully to",
        "Failed to send invoice": "Failed to send invoice",
        "Failed to generate PDF preview": "Failed to generate PDF preview",
        "Please select a vendor/supplier": "Please select a vendor/supplier",
        "Bill from": "Bill from",
        "Vendor": "Vendor",
        "Expense recorded successfully": "Expense recorded successfully",
        "Failed to record expense": "Failed to record expense",
        "Payment recorded successfully": "Payment recorded successfully",
        "Failed to record payment": "Failed to record payment",
        "Failed to load reports data": "Failed to load reports data",
        "Generating CSV...": "Generating CSV...",
        "PDF Export requires backend wkhtmltopdf integration in this MVP. Use CSV for now.": "PDF Export requires backend wkhtmltopdf integration in this MVP. Use CSV for now.",
        "Client / Vendor Name": "Client / Vendor Name",

        // Categories
        "SALES MASTER": "SALES MASTER",
        "SERVICES": "SERVICES",
        "OTHER INCOME": "OTHER INCOME",
        "PURCHASE MASTER": "PURCHASE MASTER",
        "RENT": "RENT",
        "PAYROLL": "PAYROLL",
        "UTILITY": "UTILITY",
        "OFFICE SUPPLIES": "OFFICE SUPPLIES",
        "OTHER EXPENSE": "OTHER EXPENSE",
        "RECEIPT": "RECEIPT",
        "PAYMENT OUT": "PAYMENT OUT",

        // Payment Modes
        "NEFT": "NEFT",
        "UPI": "UPI",
        "Cheque": "Cheque",
        "Cash": "Cash",
        "RTGS": "RTGS",
        "Card": "Card"
    },
    gu: {
        // General
        "Dashboard": "ડેશબોર્ડ",
        "Income": "આવક",
        "Expense": "ખર્ચ",
        "Directory": "ડિરેક્ટરી",
        "Payments": "ચુકવણીઓ",
        "Reports": "રિપોર્ટ્સ",
        "Audit Trail": "ઓડિટ ટ્રેલ",
        "Toggle Language": "ભાષા બદલો",
        "Logout": "લૉગઆઉટ",
        
        // Dashboard
        "Dashboard Overview": "ડેશબોર્ડ વિહંગાવલોકન",
        "Financial summary for the current period.": "વર્તમાન સમયગાળા માટે નાણાકીય સારાંશ.",
        "Net Income vs Expense": "ચોખ્ખી આવક vs ખર્ચ",
        "Income vs Expense Distribution": "આવક અને ખર્ચનું વિતરણ",
        "Cashflow (Received vs Going)": "રોકડ પ્રવાહ (આવક vs જાવક)",
        "Income / Sales": "આવક / વેચાણ",
        "Record sales invoices & incoming funds": "વેચાણ ઇન્વૉઇસ અને આવતા ભંડોળ રેકોર્ડ કરો",
        "Total Billed & Settled In": "કુલ આવક",
        "Total Billed & Settled Out": "કુલ જાવક",
        "Expense / Purchase": "ખર્ચ / ખરીદી",
        "Track vendor bills & purchases": "વિક્રેતાના બિલો અને ખરીદી ટ્રૅક કરો",
    // "Total Purchases": "કુલ ખરીદી",
        "Payment Master": "પેમેન્ટ માસ્ટર",
        "Two-way settlement ledger": "ટુ-વે સેટલમેન્ટ લેજર",
        "Net Cashflow": "નેટ કેશફ્લો",
        "Reports Desk": "રિપોર્ટ્સ ડેસ્ક",
        "Dynamic ledger history & export": "ડાયનેમિક લેજર હિસ્ટ્રી અને એક્સપોર્ટ",
        "P&L Balance": "P&L બેલેન્સ",

        // Party Master
        "Party Master": "પાર્ટી માસ્ટર",
        "Manage your Suppliers and Customers": "તમારા સપ્લાયર્સ અને ગ્રાહકોનું સંચાલન કરો",
        "Add Party": "પાર્ટી ઉમેરો",
        "Party Name": "પાર્ટીનું નામ",
        "Role": "ભૂમિકા",
        "GSTIN": "GSTIN",
        "Contact": "સંપર્ક",
        "Loading directory...": "ડિરેક્ટરી લોડ થઈ રહી છે...",
        "No parties found. Add one to get started.": "કોઈ પાર્ટી મળી નથી. શરૂ કરવા માટે એક ઉમેરો.",
        "Add New Party": "નવી પાર્ટી ઉમેરો",
        "Smart GST Auto-Fetch": "સ્માર્ટ GST ઑટો-ફેચ",
        "Enter 15-digit GSTIN": "15-અંકનો GSTIN દાખલ કરો",
        "Fetch": "મેળવો",
        "Party Role": "પાર્ટીની ભૂમિકા",
        "Customer (Buyer)": "ગ્રાહક (ખરીદનાર)",
        "Supplier (Vendor)": "સપ્લાયર (વેચનાર)",
        "Business Name *": "વ્યવસાયનું નામ *",
        "Full Address": "પૂરું સરનામું",
        "Contact Email": "સંપર્ક ઇમેઇલ",
        "Contact Phone": "સંપર્ક ફોન નંબર",
        "Cancel": "રદ કરો",
        "Save Party": "પાર્ટી સાચવો",
        "Or enter details manually below if API fails": "અથવા જો API નિષ્ફળ જાય તો નીચે જાતે વિગતો દાખલ કરો",

        // Income Desk
        "Income & Sales Desk": "આવક અને વેચાણ ડેસ્ક",
        "Record sales invoices, client receivables & incoming funds": "વેચાણ ઇન્વૉઇસ, ગ્રાહક લેણાં અને આવતા ભંડોળ રેકોર્ડ કરો",
        "New Income Entry": "નવી આવક નોંધણી",
        "Date": "તારીખ",
        "Category": "શ્રેણી",
        "Select Customer (Party)": "ગ્રાહક (પાર્ટી) પસંદ કરો",
        "-- Select Customer --": "-- ગ્રાહક પસંદ કરો --",
        "Itemized Details": "આઇટમવાઇઝ વિગતો",
        "Item Name / Service": "આઇટમનું નામ / સેવા",
        "Qty": "જથ્થો",
        "Rate (₹)": "દર (₹)",
        "GST %": "GST %",
        "Total": "કુલ",
        "Add Another Item": "બીજી આઇટમ ઉમેરો",
        "Grand Total": "ગ્રાન્ડ ટોટલ",
        "Record Income": "આવક રેકોર્ડ કરો",
        "Saving...": "સાચવી રહ્યું છે...",
        "Recent Sales": "તાજેતરના વેચાણ",
        "Description": "વર્ણન",
        "Amount": "રકમ",
        "Actions": "ક્રિયાઓ",
        "Preview": "પૂર્વાવલોકન",
        "Send": "મોકલો",
        "No recent income entries found.": "કોઈ તાજેતરની આવક નોંધો મળી નથી.",
        "Email Invoice PDF": "ઇન્વૉઇસ PDF ઇમેઇલ કરો",
        "Invoice Details:": "ઇન્વૉઇસ વિગતો:",
        "Recipient Email Address": "પ્રાપ્તકર્તાનું ઇમેઇલ સરનામું",
        "Cancel": "રદ કરો",
        "Send PDF": "PDF મોકલો",
        "Invoice Preview": "ઇન્વૉઇસ પૂર્વાવલોકન",
        "Email PDF": "PDF ઇમેઇલ કરો",
        "Download PDF": "PDF ડાઉનલોડ કરો",

        // Expense Desk
        "Expense & Purchase Desk": "ખર્ચ અને ખરીદી ડેસ્ક",
        "Track vendor bills, operational outlays & purchase receipts": "વિક્રેતા બિલ, કાર્યકારી ખર્ચ અને ખરીદી રસીદો ટ્રૅક કરો",
        "New Expense Entry": "નવી ખર્ચ નોંધણી",
        "Select Vendor (Supplier)": "વિક્રેતા (સપ્લાયર) પસંદ કરો",
        "-- Select Vendor --": "-- વિક્રેતા પસંદ કરો --",
        "Bill Items Details": "બિલ આઇટમ્સની વિગતો",
        "Item Name / Service / Bill Ref": "આઇટમનું નામ / સેવા / બિલ સંદર્ભ",
        "Record Expense": "ખર્ચ રેકોર્ડ કરો",
        "Recent Purchases": "તાજેતરની ખરીદીઓ",
        "Receipt Preview": "રસીદ પૂર્વાવલોકન",
        "No recent expense entries found.": "કોઈ તાજેતરની ખર્ચ નોંધો મળી નથી.",

        // Payment Desk
        "Payment Master Desk": "પેમેન્ટ માસ્ટર ડેસ્ક",
        "Two-way settlement ledger: Payment Received vs Payment Going": "ટુ-વે સેટલમેન્ટ લેજર: પ્રાપ્ત ચૂકવણીઓ vs જાવક ચૂકવણીઓ",
        "Record Settlement": "સેટલમેન્ટ રેકોર્ડ કરો",
        "Flow Type": "ફ્લોનો પ્રકાર",
        "Received (In)": "પ્રાપ્ત (આવક)",
        "Going (Out)": "જાવક (ખર્ચ)",
        "Payment Mode": "ચુકવણી મોડ",
        "Amount (₹)": "રકમ (₹)",
        "Total Received": "કુલ પ્રાપ્ત",
        "Total Going": "કુલ જાવક",
        "Settlement Ledger": "સેટલમેન્ટ લેજર",
        "Last 10 entries": "છેલ્લી 10 નોંધો",
        "Party": "પાર્ટી",
        "Mode": "મોડ",
        "Received": "પ્રાપ્ત",
        "Going": "જાવક",
        "No payment records found.": "કોઈ ચુકવણી રેકોર્ડ મળ્યા નથી.",

        // Reports Desk
        "Reports & Reconciliation": "રિપોર્ટ્સ અને સમાધાન",
        "Dynamic ledger history & export center": "ડાયનેમિક લેજર ઇતિહાસ અને એક્સપોર્ટ સેન્ટર",
        "Financial Year": "નાણાકીય વર્ષ",
        "Start Date": "શરૂઆતની તારીખ",
        "End Date": "અંતની તારીખ",
        "Types": "પ્રકારો",
        "All Types": "તમામ પ્રકારો",
        "Selected": "પસંદ કરેલ",
        "Categories": "શ્રેણીઓ",
        "All Categories": "તમામ શ્રેણીઓ",
        "Select All": "બધા પસંદ કરો",
        "Deselect All": "બધા નાપસંદ કરો",
        "Export CSV": "CSV એક્સપોર્ટ કરો",
        "Export PDF": "PDF એક્સપોર્ટ કરો",
        "Period Inflow": "સમયગાળાની આવક",
        "Period Outflow": "સમયગાળાની જાવક",
        "Net Period Balance": "ચોખ્ખી બેલેન્સ",
        "Type": "પ્રકાર",
        "Party Name": "પાર્ટીનું નામ",
        "Loading ledger data...": "લેજર ડેટા લોડ થઈ રહ્યો છે...",
        "No records found for selected filters.": "પસંદ કરેલા ફિલ્ટર્સ માટે કોઈ રેકોર્ડ મળ્યા નથી.",
        "Payment In": "પ્રાપ્ત ચુકવણી",
        "Payment Out": "જાવક ચુકવણી",

        // Toast and Dynamic strings
        "Please select a party": "કૃપા કરીને પાર્ટી પસંદ કરો",
        "Please add at least one valid line item": "કૃપા કરીને ઓછામાં ઓછી એક માન્ય આઇટમ ઉમેરો",
        "Invoice to": "ઇન્વૉઇસ:",
        "Customer": "ગ્રાહક",
        "Income recorded successfully": "આવક સફળતાપૂર્વક રેકોર્ડ થઈ",
        "Failed to record income": "આવક રેકોર્ડ કરવામાં નિષ્ફળ",
        "Invoice sent successfully to": "ઇન્વૉઇસ સફળતાપૂર્વક મોકલવામાં આવ્યું:",
        "Failed to send invoice": "ઇન્વૉઇસ મોકલવામાં નિષ્ફળ",
        "Failed to generate PDF preview": "PDF પૂર્વાવલોકન બનાવવામાં નિષ્ફળ",
        "Please select a vendor/supplier": "કૃપા કરીને વિક્રેતા/સપ્લાયર પસંદ કરો",
        "Bill from": "બિલ મોકલનાર:",
        "Vendor": "વિક્રેતા",
        "Expense recorded successfully": "ખર્ચ સફળતાપૂર્વક રેકોર્ડ થયો",
        "Failed to record expense": "ખર્ચ રેકોર્ડ કરવામાં નિષ્ફળ",
        "Payment recorded successfully": "ચુકવણી સફળતાપૂર્વક રેકોર્ડ થઈ",
        "Failed to record payment": "ચુકવણી રેકોર્ડ કરવામાં નિષ્ફળ",
        "Failed to load reports data": "રિપોર્ટ્સ ડેટા લોડ કરવામાં નિષ્ફળ",
        "Generating CSV...": "CSV જનરેટ થઈ રહ્યું છે...",
        "PDF Export requires backend wkhtmltopdf integration in this MVP. Use CSV for now.": "આ MVP માં PDF નિકાસ માટે બેકએન્ડ પર wkhtmltopdf ની જરૂર છે. અત્યારે CSV નો ઉપયોગ કરો.",
        "Client / Vendor Name": "ગ્રાહક / વિક્રેતાનું નામ",

        // Categories
        "SALES MASTER": "મુખ્ય વેચાણ",
        "SERVICES": "સેવાઓ",
        "OTHER INCOME": "અન્ય આવક",
        "PURCHASE MASTER": "મુખ્ય ખરીદી",
        "RENT": "ભાડું",
        "PAYROLL": "પગારપત્રક",
        "UTILITY": "ઉપયોગિતા",
        "OFFICE SUPPLIES": "ઑફિસ સામગ્રી",
        "OTHER EXPENSE": "અન્ય ખર્ચ",
        "RECEIPT": "રસીદ",
        "PAYMENT OUT": "ચુકવણી",

        // Payment Modes
        "NEFT": "NEFT",
        "UPI": "UPI",
        "Cheque": "ચેક",
        "Cash": "રોકડ",
        "RTGS": "RTGS",
        "Card": "કાર્ડ"
    }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
    const [language, setLanguage] = useState(localStorage.getItem('appLanguage') || 'en');

    const toggleLanguage = () => {
        const newLang = language === 'en' ? 'gu' : 'en';
        setLanguage(newLang);
        localStorage.setItem('appLanguage', newLang);
    };

    const t = (key) => {
        return translations[language][key] || key;
    };

    return (
        <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    return useContext(LanguageContext);
}
